<template>
  <div>
    <div class="content" style="width: auto">
      <div class="cont-list">
        <span class="list">{{ this.parentRoute.menuName }}-{{ title }}产品注册证维护</span>
      </div>
      <el-form label-position="top" label-width="80px" ref="form" :model="form" :rules="rules">
        <div class="edit-card">
          <div style="width: 88%; display: flex">
            <div class="start-label" />
            <span class="text">原产品注册证基础信息</span>
          </div>
          <el-row>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
                <el-form-item v-if="getIsView()" label="注册证分类" prop="oldType">
                    <el-select v-model="form.oldType" placeholder="请选择注册证分类" style="width: 100%" disabled clearable  >
                        <template v-for="item in WarehouseTypeOptions">
                        <el-option :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </template>
                    </el-select>
                </el-form-item>
                <span class="viewText" v-else>注册证分类: {{ form.oldType }}</span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''"> 
              <el-form-item v-if="getIsView()" :label="form.sourceType==1?'注册证号':'批准文号'" prop="oldNo">
                <el-input v-model="form.oldNo" disabled></el-input>
              </el-form-item>
                <span class="viewText" v-else>{{ form.sourceType==1?'注册证号':'批准文号' }}: {{ form.oldNo }}</span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''"> 
              <el-form-item v-if="getIsView()" label="注册证名称" prop="oldName">
                <el-input v-model="form.oldName" disabled></el-input>
              </el-form-item>
              <span class="viewText" v-else>注册证名称: {{ form.oldName }}</span>
            </el-col>
            <!-- <el-col :span="6">
              <el-form-item label="产品通用名" prop="productCommonName">
                <el-input v-model="form.productCommonName" :disabled="!editMode" placeholder="请填写产品通用名"></el-input>
              </el-form-item>
            </el-col> -->
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item v-if="getIsView()" label="生产厂家" prop="manufacturerId">
                <el-input v-model="form.oldManufacturerName" disabled></el-input>
              </el-form-item>
              <span class="viewText" v-else>生产厂家: {{ form.oldManufacturerName }}</span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item v-if="getIsView()" label="售后代理商" prop="manufacturerId">
                <el-input v-model="form.oldAgentName" disabled></el-input>
              </el-form-item>
              <span class="viewText" v-else>售后代理商: {{ form.oldAgentName }}</span>
            </el-col>
              <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item v-if="getIsView()" label="注册备案人" prop="oldRegistrantUserName">
                <el-input v-model="form.oldRegistrantUserName" disabled></el-input>
              </el-form-item>
              <span class="viewText" v-else>注册备案人: {{ form.oldRegistrantUserName }}</span>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12" :class="!getIsView()?'viewCol':''">
              <el-form-item v-if="getIsView()" label="对应经营范围" prop="oldSupplierManageRangeIds">
                <el-select v-model="form.oldSupplierManageRangeIds" disabled multiple style="width: 100%">
                  <el-option v-for="item in STATIC_ManageRanges" :key="item.id" :label="item.name"
                    :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <span class="viewText" v-else>对应经营范围: {{ form.oldSupplierManageRangeIds }}</span>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="10" :class="!getIsView()?'viewCol':''">
              <el-form-item v-if="getIsView()" label="生效日期" prop="oldStartDate">
                <el-date-picker v-model="form.oldStartDate" disabled type="date" placeholder="请选择生效日期"
                  style="width: 100%"></el-date-picker>
              </el-form-item>
              <span class="viewText" v-else>生效日期: {{ parseTime(new Date(form.oldStartDate), "{y}-{m}-{d}") }}</span>
            </el-col>
            <el-col :span="10" :class="!getIsView()?'viewCol':''">
              <el-form-item v-if="getIsView()" label="失效日期" prop="oldEndDate">
                <el-date-picker v-model="form.oldEndDate" disabled type="date" placeholder="选择失效日期"
                  style="width: 100%"></el-date-picker>
              </el-form-item>
              <span class="viewText" v-else>失效日期: {{ parseTime(new Date(form.oldEndDate), "{y}-{m}-{d}") }}</span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item v-if="getIsView()" style="margin-left: 10px; margin-top: 30px">
                <el-checkbox disabled v-model="form.oldLongTime">长期</el-checkbox>
              </el-form-item>
              <span class="viewText" v-else>长期: {{ form.oldLongTime?'是':'否' }}</span>
            </el-col>
          </el-row>
        </div>

        <div class="edit-card" style="margin-top: 10px; padding-bottom: 10px">
          <div style="width: 88%; display: flex">
            <div class="start-label" />
            <span class="text">产品注册证基础信息</span>
          </div>
          <el-row>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item v-if="getIsView()" label="注册证分类" prop="sourceType">
                    <el-select v-model="form.sourceType" :disabled="!editMode" placeholder="请选择注册证分类" style="width: 100%" clearable  >
                        <template v-for="item in WarehouseTypeOptions">
                        <el-option :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </template>
                    </el-select>
                </el-form-item>
                <span class="viewText" v-else>注册证分类: {{ form.sourceType }}</span>
              </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item v-if="getIsView()" :label="form.sourceType==1?'注册证号':'批准文号'" prop="no">
                <el-input v-model="form.no" :disabled="!editMode" :class="Boolean(form.productRegistCertId) && form.no != form.oldNo
                    ? 'change-content'
                    : ''
                  " ></el-input>
              </el-form-item>
              <span class="viewText" v-else>{{ form.sourceType==1?'注册证号':'批准文号' }}: {{ form.no }}</span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item v-if="getIsView()" label="注册证名称" prop="name">
                <el-input v-model="form.name" :disabled="!editMode" :class="Boolean(form.productRegistCertId) && form.name != form.oldName
                    ? 'change-content'
                    : ''
                  " placeholder="请填写注册证名称"></el-input>
              </el-form-item>
              <span class="viewText" v-else>注册证名称: {{ form.name }}</span>
            </el-col>
            <!-- <el-col :span="6">
              <el-form-item label="产品通用名" prop="productCommonName">
                <el-input v-model="form.productCommonName" :disabled="!editMode" placeholder="请填写产品通用名"></el-input>
              </el-form-item>
            </el-col> -->
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item v-if="getIsView()" label="生产厂家" prop="manufacturerId">
                <el-select v-model="form.manufacturerName" :disabled="!editMode" :class="Boolean(form.productRegistCertId) &&
                    form.manufacturerName != form.oldManufacturerName
                    ? 'change-content'
                    : ''
                  " placeholder="请选择生产厂商" :filter-method="(keyWord) => getManufacturers(keyWord, 1)" filterable
                  @change="manufacturerChange" style="width: 100%">
                  <el-option v-for="item in STATIC_Manufacturers" :key="item.id" :label="item.name"
                    :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <span class="viewText" v-else>生产厂家: {{ form.manufacturerName }}</span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item v-if="getIsView()" label="售后代理商" prop="agentName">
                <el-select v-model="form.agentName" :disabled="!editMode" :class="Boolean(form.productRegistCertId) &&
                    form.manufacturerName != form.oldManufacturerName
                    ? 'change-content'
                    : ''
                  " placeholder="请选择售后代理商" :filter-method="(keyWord) => getManufacturers(keyWord, 1)" filterable
                  @change="agentNameChange" style="width: 100%">
                  <el-option v-for="item in STATIC_Manufacturers" :key="item.id" :label="item.name"
                    :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <span class="viewText" v-else>售后代理商: {{ form.agentName }}</span>
            </el-col>

            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item v-if="getIsView()" label="注册备案人" prop="oldRegistrantUserName">
                <el-select el-select v-model="form.registrantUserName" :disabled="!editMode" :class="Boolean(form.productRegistCertId) &&
                    form.manufacturerName != form.oldManufacturerName
                    ? 'change-content'
                    : ''
                  " :filter-method="(keyWord) => getManufacturers(keyWord, 1)" filterable
                  @change="registrantUserChange" style="width: 100%">
                  <el-option v-for="item in STATIC_Manufacturers" :key="item.id" :label="item.name"
                    :value="item.id"></el-option>
                </el-select>

              </el-form-item>
              <span class="viewText" v-else>注册备案人: {{ form.registrantUserName }}</span>
            </el-col>

          </el-row>

          <el-row>
            <el-col :span="12" :class="!getIsView()?'viewCol':''">
              <el-form-item v-if="getIsView()" label="对应经营范围" prop="supplierManageRangeIds">
                <el-select v-model="form.supplierManageRangeIds" :disabled="!editMode" placeholder="请选择经营范围" :class="Boolean(form.productRegistCertId) && form.rangeIds != form.oldRangeIds
                    ? 'change-content'
                    : ''
                  " :filter-method="getManageRanges" filterable multiple style="width: 100%">
                  <el-option v-for="item in STATIC_ManageRanges" :key="item.id" :label="item.name"
                    :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <span class="viewText" v-else>对应经营范围: {{ form.supplierManageRangeIds }}</span>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="10" :class="!getIsView()?'viewCol':''">
              <el-form-item v-if="getIsView()" label="生效日期" prop="startDate">
                <el-date-picker v-model="form.startDate" :disabled="!editMode" type="date" placeholder="请选择生效日期" :class="Boolean(form.productRegistCertId) &&
                    form.startDate != form.oldStartDate
                    ? 'change-content'
                    : ''
                  " style="width: 100%"></el-date-picker>
              </el-form-item>
              <span class="viewText" v-else>生效日期: {{ parseTime(new Date(form.startDate), "{y}-{m}-{d}") }}</span>
            </el-col>
            <el-col :span="10" :class="!getIsView()?'viewCol':''">
              <el-form-item v-if="getIsView()" label="失效日期" prop="endDate">
                <el-date-picker v-model="form.endDate" :disabled="!editMode" type="date" placeholder="选择失效日期" :class="Boolean(form.productRegistCertId) && form.endDate != form.oldEndDate
                    ? 'change-content'
                    : ''
                  " @change="endDateEvt" style="width: 100%"></el-date-picker>
              </el-form-item>
              <span class="viewText" v-else>失效日期: {{ parseTime(new Date(form.endDate), "{y}-{m}-{d}")  }}</span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item v-if="getIsView()" style="margin-left: 10px; margin-top: 30px">
                <el-checkbox :disabled="!editMode" v-model="form.longTime" @change="longTimeEvt">长期</el-checkbox>
              </el-form-item>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item v-if="getIsView()" style="margin-left: 10px; margin-top: 30px">
                <el-checkbox :disabled="!editMode" v-model="form.longTime" @change="longTimeEvt">长期</el-checkbox>
              </el-form-item>
              <span class="viewText" v-else>长期</span>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12" :class="!getIsView()?'viewCol':''">
              <el-form-item v-if="getIsView()" label="备注" prop="remark">
                <el-input v-model="form.remark" :disabled="!editMode" placeholder="请填写备注" resize="none" type="textarea"
                  :rows="5" style="width: 95%"></el-input>
              </el-form-item>
              <span class="viewText" v-else>备注: {{ form.remark }}</span>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item prop="fileInfos" label="">
                <UploadFileList label="上传附件" :fileList="form.fileInfos ? form.fileInfos : []" btnShowType="always"
                  :multipleFile="false" :showFileList="true" :editMode="editMode" @fileChange="filesChange">
                </UploadFileList>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <ApproveInfo ref="approveInfo" v-if="showWorkFlowInfo" @change="approveInfoChange"></ApproveInfo>
      </el-form>
    </div>
    <div slot="footer" class="footer-bottom">
      <el-button v-if="editMode" class="btn default" v-preventReClick @click="cancel">取 消</el-button>
      <my-button v-if="editMode" class="btn primary" type="primary" v-preventReClick @click="submit">确 定</my-button>
      <my-button v-if="showWorkFlowInfo" class="btn primary" type="primary" v-preventReClick @click="approve">确
        定</my-button>
      <el-button v-if="!editMode" class="btn default" v-preventReClick @click="cancel">返 回</el-button>
      <!-- <el-button class="btn default" v-preventReClick @click="cancel">取 消</el-button>
      <my-button class="btn primary" type="primary" v-if="editMode" v-preventReClick @click="submit">确 定</my-button> -->
    </div>
    <!-- <el-image-viewer :openViewer="dialogVisible" :fileId="fileId" :fileName="fileName" @closeImageViewer="closeImageViewer" /> -->
  </div>
</template>

<script>
import GetDataMixin from "@/mixin/getData-mixin.js";
import {
  GetProductRegistCertUpdateById,
  SaveProductRegistCertUpdate,
  RejectProductRegistCertUpdate,
} from "@/api";
import {
  SupplierCategoryOptions,
  WarehouseTypeOptions,
  // LevelOptions,
  // ManufacturerCertificateOptions,
} from "@/enum";
// import Address from "@/components/address";
// import MyUpload from "@/components/my-upload";
// import ElImageViewer from "@/components/elImageViewer";
import ApproveInfo from "@/components/approve-info";
import UploadFileList from "@/components/upload-file-list";

export default {
  name: "manufacturerUpdateEdit",
  mixins: [GetDataMixin],
  components: {
    // Address,
    // MyUpload,
    // ElImageViewer,
    ApproveInfo,
    UploadFileList,
  },
  data () {
    return {
      reject: RejectProductRegistCertUpdate,

      title: "",
      form: {},
      // 生产厂商证件类型
      // ManufacturerCertificateOptions: ManufacturerCertificateOptions,
      SupplierCategoryOptions: SupplierCategoryOptions,
      WarehouseTypeOptions: WarehouseTypeOptions,
      // LevelOptions: LevelOptions,
      rules: {
        sourceType: [
          {
            required: true,
            message: "请选择注册证分类",
            trigger: "blur",
          },
        ],
        name: [
          {
            required: true,
            message: "厂商名称不能为空",
            trigger: "blur",
          },
        ],
        category: [
          {
            required: true,
            message: "厂商类型不能为空",
            trigger: "blur",
          },
        ],
        // creditCode: [
        //   { required: true, message: "社会信用代码不能为空", trigger: "blur" },
        // ],
        // contactor: [
        //   { required: true, message: "联系人不能为空", trigger: "blur" },
        // ],
        // phone: [
        //   { required: true, message: "联系电话不能为空", trigger: "blur" },
        // ],
        // productionRangeName: [
        //   { required: true, message: '请选择生产范围', trigger: 'blur' }
        // ],
      },
      editMode: false,
    };
  },
  props: {
    // title: {
    //   type: String,
    //   default () {
    //     return ''
    //   }
    // }
  },
  created () {
    var query = this.$route.query;
    if (query.id) {
      this.handleUpdate(query.id);
    } else {
      this.handleAdd();
    }

    this.getManufacturers("");
    this.getManageRanges("", 1);
  },
  methods: {
    // 新建
    handleAdd () {
      this.title = "新建";
      this.resetForm();
      this.editMode = true;
    },
    // 编辑
    handleUpdate (id) {
      GetProductRegistCertUpdateById({
        id,
      }).then((res) => {
        this.resetForm();
        this.form = res.returnData;
        this.title = "编辑";

        this.form.oldRangeIds = this.form.oldSupplierManageRangeIds;
        this.form.rangeIds = this.form.supplierManageRangeIds;
        this.form.supplierManageRangeIds = this.form.supplierManageRangeIds
          ? this.form.supplierManageRangeIds.split(";").map((item) => {
            return item * 1;
          })
          : [];
        if (res.returnData.manageRangeInfos) {
          res.returnData.manageRangeInfos.map((range) => {
            let arr = this.STATIC_ManageRanges.filter((e) => e.id == range.id);
            if (!arr || arr.length == 0) {
              this.STATIC_ManageRanges.push(range);
            }
          });
        }

        this.form.oldSupplierManageRangeIds = this.form.oldSupplierManageRangeIds
          ? this.form.oldSupplierManageRangeIds.split(";").map((item) => {
            return item * 1;
          })
          : [];
        if (res.returnData.oldManageRangeInfos) {
          res.returnData.oldManageRangeInfos.map((range) => {
            let arr = this.STATIC_ManageRanges.filter((e) => e.id == range.id);
            if (!arr || arr.length == 0) {
              this.STATIC_ManageRanges.push(range);
            }
          });
        }
        this.form.longTime = res.returnData.longTime == 1 ? true : false;
        this.form.oldLongTime = res.returnData.oldLongTime == 1 ? true : false;
        this.initWorkFlowProperty(this.form);
      });
    },
    // 保存
    submit () {
      if (!this.form.longTime && !this.form.endDate) {
        this.$message.error("失效日期和长期必须选一个");
        return;
      }
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          return false;
        }

        this.form["oldSupplierManageRangeIds"] = this.form["oldSupplierManageRangeIds"]
          ? this.form["oldSupplierManageRangeIds"].join(";")
          : "";
        this.form["supplierManageRangeIds"] = this.form["supplierManageRangeIds"]
          ? this.form["supplierManageRangeIds"].join(";")
          : "";
        this.form.longTime = this.form.longTime == true ? 1 : 0;
        this.form.oldLongTime = this.form.oldLongTime == true ? 1 : 0;
        SaveProductRegistCertUpdate(this.form)
          .then((res) => {
            this.$my_message(`执行成功`, "success");
            sessionStorage.setItem("editMode", 0);
            // this.$router.push({ path: this.getMainPath(this.$route.path) });
            this.routePushWithParams(
              this.getMainPath(this.$route.path),
              this.$route.params
            );
          })
          .finally(() => {
            this.$store.dispatch('SetLoading',false)
            this.form["oldSupplierManageRangeIds"] = this.form[
              "oldSupplierManageRangeIds"
            ]
              ? this.form["oldSupplierManageRangeIds"].split(";")
              : "";
            this.form["supplierManageRangeIds"] = this.form["supplierManageRangeIds"]
              ? this.form["supplierManageRangeIds"].split(";")
              : "";
          });
      });
    },
    resetForm () {
      this.form = {
        sourceType:[1],
        name: "",
        state: 1,
        countryId: 0,
        provinceId: 0,
        cityId: 0,
        details: [],
        productionRangeName: [],
        productionRangeId: "",
        fileInfos: [],
        orgCode :sessionStorage.getItem('orgId'),
      };
    },

    endDateEvt (val) {
      this.form.endDate = val;
      this.form.longTime = false;
      this.$forceUpdate();
    },
    longTimeEvt (boolean) {
      if (boolean == true) {
        this.form.endDate = null;
      }
      this.$forceUpdate();
    },
       // 取消编辑
    cancel () { 
      this.$store.dispatch('SetLoading',false)
      // this.$my_confirm("确认要中断当前操作吗？", "提示", {
      //   type: "warning",
      // }).then(() => {
      //   });
      // this.$router.push({ path: this.getMainPath(this.$route.path) });
      this.routePushWithParams(this.getMainPath(this.$route.path), this.$route.params);
    },

    manufacturerChange (val) {
      this.form.manufacturerId = val;
    },
    registrantUserChange(val){
      this.form.registrantUser = val
    },
    agentNameChange(val){
      this.form.agentId = val
    },
    // 上传附件
    filesChange (fileList) {
      this.form.fileInfos = fileList;
    },
  },
};
</script>

<style lang="scss" scoped></style>
